export const calculateTotalRate = (amount: string | number, percent: number, month: number, tax?: number): number => {
  let interest = Number(amount) * (((percent / 12) * month) / 100);

  if (tax) {
    interest = interest - (interest * tax / 100);
  }

  return Math.round(interest);
};

export const calculateTotalSum = (amount: string | number, percent: number, month: number, tax?: number): number => {
  return Math.round(calculateTotalRate(amount, percent, month, tax) + Number(amount));
};
